<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field
                                v-model="concern_alias"
                                :rules="[formRules.required]"
                                label="Area of Concern"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="deadline_alias"
                                label="Deadline Alias"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-card elevation="4">
                                <v-card-text >
                                    <div style="display: flex; flex-direction: column;" class="ga-2">
                                        <div v-for="report in reportData.reports">
                                            <div style="display: flex; justify-content: space-between;">
                                                <strong>{{ report.officeAbbrev }}</strong>
                                                <span class="text-body-2">🟢 Before Deadline: {{ report.beforeDeadlinePercentage }}% ({{ report.beforeDeadlineCount }})</span>
                                            </div>
                                            <div style="display: flex; justify-content: space-between; padding-left: 1.5rem;">
                                                <span style="visibility: hidden;">{{ report.officeAbbrev }}</span>
                                                <span class="text-body-2">🔴 After Deadline: {{ report.afterDeadlinePercentage }}% ({{ report.afterDeadlineCount }})</span>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="mt-4">
                            <v-textarea
                                v-model="remarks"
                                label="Remarks"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                auto-grow
                                >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            concern_alias: null,
            deadline_alias: null,
            compliance_id: null,
            term_id: null,
            remarks: null,
            created_by: null,

            reportData: [],
        }
     },
     methods: {
        initEdit(data){
            this.dialog = true
            this.dialog_title = 'Report Details'
            this.dialog_sub_title = 'Edit the details for this complaince'

            if(!data.complianceDetailId){
                this.action = 'add'
            }
            else{
                this.action = 'edit'
                this.id = data.complianceDetailId
            }
            
            if(this.formatDate(data.deadline) == false){
                this.deadline_alias = data.deadline
            }

            if(data.termId){
                this.term_id = data.termId
            }
            else {
                this.term_id = null
            }

            if(!data.remarks){
                this.remarks = data.reports.map(report => `${report.officeAbbrev} -`).join('\n');
            }
            else{
                this.remarks = data.remarks
            }

            this.concern_alias = data.concern
            this.compliance_id = data.complianceId
            this.reportData = data
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()

            const { valid } = await this.$refs.form.validate()
            
            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    concern_alias: this.concern_alias,
                    deadline_alias: this.deadline_alias,
                    compliance_id: this.compliance_id,
                    term_id: this.term_id,
                    semester_schoolyear: this.$store.state.semester_schoolyear.id,
                    remarks: this.remarks,
                }
                const token = localStorage.getItem('aums-token')

                if(this.action == 'add'){
                    axios.post(process.env.VUE_APP_SERVER_URL + '/consolidated-report-details', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Compliance Details successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/consolidated-report-details/' + this.id, formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Compliance Details successfully updated!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        formatDate(value) {
            const date = new Date(value);
            if (isNaN(date.getTime())) {
                return false;
            }
            return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            });
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>